// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Xpgy0jHI3K4YEfRknl5aw","favoriteButton":"_3k1DxZ56RaMP9y7SjwdGTg","isFocused":"_3QvsmOvKtb5tGcsD7fFAzD"};